import * as React from 'react';
import { useGroundingMenuSubmenuHeader_unstable } from './useGroundingMenuSubmenuHeader';
import { renderGroundingMenuSubmenuHeader_unstable } from './renderGroundingMenuSubmenuHeader';
import { useGroundingMenuSubmenuHeaderStyles_unstable } from './useGroundingMenuSubmenuHeaderStyles.styles';
import type { GroundingMenuSubmenuHeaderProps } from './GroundingMenuSubmenuHeader.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenuSubmenuHeader component - TODO: add more docs
export const GroundingMenuSubmenuHeader: ForwardRefComponent<GroundingMenuSubmenuHeaderProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingMenuSubmenuHeader_unstable(props, ref);

    useGroundingMenuSubmenuHeaderStyles_unstable(state);
    return renderGroundingMenuSubmenuHeader_unstable(state);
  },
);

GroundingMenuSubmenuHeader.displayName = 'GroundingMenuSubmenuHeader';
